import React from 'react';
import Meta from "../components/Meta";
import PageBanner from '../components/PageBanner';
import BookingInfo from '../components/BookingInfo';
import Location from '../components/Location';

const BookNow = () => {
    return (
        <>
            <Meta title="Book Now - THE CUTTING BAR" />
            <PageBanner imageUrl="assets/images/background/6.jpg" heading="Booking" />
            <BookingInfo />
            <Location />
        </>
    );
}

export default BookNow;
